import React from "react";
function MyKundli() {
  const chartData = {
    chartDescription:
      "Capricorn is ruled by Saturn, the planet of discipline and responsibility, which makes them ambitious, hardworking, and highly focused on long-term goals. They are natural planners who value structure, tradition, and stability in life.",
    planetaryPeriods: [
      { name: "Sun", house: "11th", sign: "Taurus", deg: "3.92°" },
      { name: "Moon", house: "10th", sign: "Taurus", deg: "3.92°" },
      { name: "Mercury", house: "11th", sign: "Taurus", deg: "3.92°" },
      { name: "Sun", house: "10th", sign: "Taurus", deg: "3.92°" },
      { name: "Sun", house: "11th", sign: "Taurus", deg: "3.92°" },
      { name: "Sun", house: "11th", sign: "Taurus", deg: "3.92°" },
    ],
  };

  // Component for a Kundli Chart block (Natal, Lagna, Navamsa)
  const KundliChartBlock = ({ title, description, imageSrc }) => (
    <div className="mb-10">
      {/* Chart Image */}
      <div className="flex justify-center mb-4">
        <img
          // Note: Replace this placeholder path with your actual image/SVG source
          src={imageSrc}
          alt={`${title} Chart`}
          className="max-w-xs sm:max-w-sm w-full object-contain"
        />
      </div>

      {/* Description */}
      <p className="text-base text-gray-600 leading-relaxed max-w-4xl mx-auto">
        {description}
      </p>

      {/* Title, positioned below the description for all but the first chart */}
      {title && (
        <h3 className="text-xl font-bold text-gray-950 mt-8 mb-4">{title}</h3>
      )}
    </div>
  );

  // Component for the Planetary Periods table
  const PlanetaryTable = ({ periods }) => (
    <div className="mt-10">
      <h2 className="text-2xl font-bold text-gray-950 mb-4">
        Planetary Periods
      </h2>
      <div className="overflow-x-auto rounded-lg">
        <table className="min-w-full table-auto border-collapse">
          <thead>
            <tr className="bg-gray-100 text-left web-h6 text-gray-950">
              <th className="py-3 px-4">Name</th>
              <th className="py-3 px-4">House</th>
              <th className="py-3 px-4">Sign</th>
              <th className="py-3 px-4">Deg</th>
            </tr>
          </thead>
          <tbody>
            {periods.map((planet, index) => (
              <tr
                key={index}
                className={`web-body-md text-gray-700 ${
                  index % 2 === 0 ? "bg-white" : "bg-gray-50"
                }`}
              >
                <td className="py-3 px-4">{planet.name}</td>
                <td className="py-3 px-4">{planet.house}</td>
                <td className="py-3 px-4">{planet.sign}</td>
                <td className="py-3 px-4">{planet.deg}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  const { chartDescription, planetaryPeriods } = chartData;

  return (
    <>
      <section className="notifications-bg py-8 md:py-12 bg-white min-h-screen">
        <div className="container">
          {/* Header and Action Buttons */}
          <div className="flex justify-between flex-wrap gap-[10px] items-center mb-6 md:mb-8">
            <h1 className="web-h3 text-gray-950">My Kundli</h1>
            <div className="flex space-x-3">
              <button className="custom-btn custom-btn-secondary">
                Save Report
              </button>
              <button className="custom-btn custom-btn-primary">
                Talk to Astrologer
              </button>
            </div>
          </div>

          {/* Main Content: Two Columns */}
          <div className="flex flex-col lg:flex-row gap-6">
            {/* --- LEFT COLUMN: Report Details --- */}
            <div className="lg:w-3/4 bg-white p-[15px] md:p-[20px] rounded-[20px] border border-gray-100">
              <div className="">
                <KundliChartBlock
                  title="Lagna Kundli"
                  description={chartDescription}
                  // Using a placeholder for the image path.
                  imageSrc="/images/kundli.png"
                />

                <KundliChartBlock
                  title="Navamsa Chart"
                  description={chartDescription}
                  // Using a placeholder for the image path.
                  imageSrc="/images/kundli.png"
                />  

                <KundliChartBlock
                  title="Navamsa Chart"
                  description={chartDescription}
                  // Using a placeholder for the image path.
                  imageSrc="/images/chart.png"
                />  

                {/* 4. Planetary Periods Table */}
                <PlanetaryTable periods={planetaryPeriods} />
              </div>
            </div>

            {/* --- RIGHT COLUMN: Profile Card (Fixed Width) --- */}
            <div className="lg:w-1/4 flex-shrink-0">
              <div className="text-center bg-primary-50 p-[15px] md:p-[20px] rounded-[20px]">
                <div className="flex justify-between items-start p-[15px] bg-white border border-gray-100 rounded-[10px]">
                  <div className="text-left flex flex-col gap-[5px]">
                    <h3 className="web-h4 text-gray-950">Arjun Malhotra</h3>
                    <p className="body-md text-gray-950">10th Jan 1997</p>
                  </div>
                  {/* Edit Icon */}
                  <button className="text-gray-500 hover:text-gray-700 p-1 rounded-full transition-colors">
                    <img src="/images/edit.svg" alt="Edit" />
                  </button>
                </div>

                {/* Lucky Details */}
                <div className="space-y-4 pt-4 border-t border-gray-100">
                  <div className="flex items-center justify-between text-base flex-col gap-[5px]">
                    <h5 className="web-h5 text-gray-950">Mangal Dosha</h5>
                    <span className="web-h5 text-green-600">Yes</span>
                  </div>

                  <div className="flex items-center justify-between text-base flex-col gap-[2px]">
                    <span className="web-body-md text-gray-950">
                      Meera Kapoor
                    </span>
                    <span className="web-h5 text-red-600">No</span>
                  </div>

                  <div className="flex items-center justify-between text-base flex-col gap-[2px]">
                    <span className="web-body-md text-gray-950">
                      Arjun Malhotra
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default MyKundli;
